export const getSlackAskBotConnectionUrl = (workspaceAlias: string) => {
  return `https://slack.com/oauth/v2/authorize?client_id=1700263324773.9682055541109&scope=channels:history,channels:read,chat:write,commands,groups:history,groups:read,groups:write,im:history,im:read,im:write,mpim:history,mpim:read,mpim:write,users:read,users:read.email&user_scope=&client_id=${
    import.meta.env.VITE_PUBLIC_SLACK_ASK_BOT_CLIENT_ID
  }&state=${workspaceAlias}`;
};
